import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wifi, Gift, ClipboardList, Coffee, UserPlus, Star, ArrowRight, ShieldCheck } from "lucide-react";
import { CraftLogo, LangSwitcher, CraftFooter } from "../components/Shared";
import { useLang } from "../i18n";
import { api } from "../lib/api";

const TYPE_STYLE = {
  wifi: { icon: Wifi, color: "bg-[#FEBC10]" },
  promo: { icon: Gift, color: "bg-[#FF0000] text-white" },
  survey: { icon: ClipboardList, color: "bg-[#111] text-white" },
  loyalty: { icon: Coffee, color: "bg-[#FEBC10]" },
  review: { icon: Star, color: "bg-[#FF0000] text-white" },
  lead: { icon: UserPlus, color: "bg-white border border-gray-200" },
  custom: { icon: Gift, color: "bg-[#FEBC10]" },
};

export default function Landing() {
  const { L } = useLang();
  const [campaigns, setCampaigns] = useState(null);

  useEffect(() => {
    api.get("/public/campaigns")
      .then(({ data }) => setCampaigns(data.campaigns || []))
      .catch(() => setCampaigns([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF3E4]">
      <div className="max-w-[430px] mx-auto min-h-screen flex flex-col">
        <div className="flex items-center justify-between px-5 pt-5 pb-3">
          <CraftLogo /><LangSwitcher />
        </div>
        <div className="px-5 flex-1">
          <h1 className="font-display font-black text-3xl leading-tight mt-2">QR Campaigns<br /><span className="text-[#FF0000]">CRAFT Fast Food</span></h1>
          <p className="text-sm text-gray-500 font-semibold mt-2 mb-5">Отсканируйте QR или откройте кампанию:</p>
          {campaigns === null ? (
            <div className="flex justify-center py-10"><div className="w-10 h-10 border-4 border-[#FEBC10] border-t-transparent rounded-full animate-spin" /></div>
          ) : (
            <div className="space-y-3">
              {campaigns.map((d) => {
                const st = TYPE_STYLE[d.type] || TYPE_STYLE.custom;
                const Icon = st.icon;
                return (
                  <Link key={d.slug} data-testid={`demo-${d.slug}`} to={`/c/${d.slug}`}
                    className="craft-card flex items-center gap-4 p-4 transition-transform active:scale-[0.98] hover:shadow-lg">
                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${st.color}`}><Icon size={22} /></div>
                    <div className="flex-1">
                      <div className="font-display font-extrabold">{L(d.name)}</div>
                      <div className="text-xs text-gray-500 font-semibold">{L(d.description)}</div>
                    </div>
                    <ArrowRight size={18} className="text-gray-300 shrink-0" />
                  </Link>
                );
              })}
              {campaigns.length === 0 && <p className="text-sm text-gray-400 font-semibold text-center py-6">Нет активных кампаний</p>}
            </div>
          )}
          <div className="flex gap-3 mt-5">
            <Link data-testid="link-admin" to="/admin" className="flex-1 craft-btn craft-btn-ghost text-sm"><ShieldCheck size={17} /> Admin</Link>
            <Link data-testid="link-staff" to="/staff" className="flex-1 craft-btn craft-btn-ghost text-sm">Staff</Link>
          </div>
        </div>
        <CraftFooter />
      </div>
    </div>
  );
}
